import React, {useEffect, useState} from 'react';
import {CircularProgress, Input, Pagination} from "@nextui-org/react";
import {Box} from "@mui/material";
import axios from "axios";
import {CardComponent} from "./card.component";
import {Search} from "@mui/icons-material";
import {useLocation} from "react-router-dom";
import {useDebounce} from "@uidotdev/usehooks";

export default function HeroComponent(props) {

    const BaseUrl = props.baseUrl;
    const Title = props.title;
    const [skins, setSkins] = useState(null);
    const config = {
        mode: 'no-cors',
        headers: {Authorization: `Bearer e8501a2c3c56b6c611930609b53c0e083fdfe24466bf536d86629c2aaa655f555cce662bc4e8ba94e5bc9c164b056e36507f8b042869d59da13ae35a10a0bc73`}
    };
    const [searchTerm, setSearchTerm] = React.useState("");

    async function fetchUrl(page) {
        let u = BaseUrl === null ? 'https://dataapi.miracocopepsi.com/public/api/minecraft/skins' : BaseUrl;
        let temp = await axios.get(page === null ? u : `${u}?page=${page}`, config);
        setSkins(temp);
    }

    async function searchSkin(text) {
        let u = `https://dataapi.miracocopepsi.com/public/api/minecraft/skins/search?searchquery=${text}`;
        let temp = await axios.get(u, config);
        setSkins(temp);
    }

    const {pathname} = useLocation();

    useEffect(() => {
        fetchUrl(1);
    }, [pathname]);

    let isCave = pathname === "/skins/caves";
    return (
        <Box key={BaseUrl} className={'overflow-hidden'}>
            <div className={'px-4 sm:px-10 md:px-12 grid md:grid-cols-2 grid-cols-1'}>
                <div className={'items-center flex'}>
                    <p className={'text-2xl md:text-4xl font-bold md:ml-20 mb-3'}>{
                        Title
                    }</p>
                </div>
                <div className={'xl:mr-10 xl:justify-end justify-center items-center flex'}>
                    <Input
                        classNames={{
                            base: "w-full md:w-2/3",
                            mainWrapper: "h-full",
                            input: "text-small",
                            inputWrapper: "h-full font-normal text-default-500 bg-default-400/20 dark:bg-default-500/20",
                        }}
                        onInput={event => {
                            if (event.currentTarget.value === "") {
                                fetchUrl(skins.data.current_page);
                            } else {
                                searchSkin(event.currentTarget.value);
                            }
                        }}

                        placeholder="search your skins"
                        size="md"
                        startContent={<Search size={18}/>}
                        type="search"
                    />
                </div>
            </div>
            {
                skins === null ? <div className={'h-screen w-screen flex justify-center mx-auto'}>
                    <CircularProgress aria-label="Loading..."/>
                </div> : <div
                    key={'grid_container'}
                    className="py-5 sm:py-0 px-4 sm:px-10 md:px-20 w-full gap-3 grid xl:grid-cols-6 lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 sm:pt-10">
                    {skins.data.data.map((item, index) => <div key={`CarHolder_${index}`}>
                        <CardComponent key={index} props={
                            {
                                "item": item,
                                "index": index,
                                "isCape": isCave
                            }
                        }/>
                    </div>)}
                </div>

            }

            {
                skins === null  ? <div/> : <center className={'mb-10'}>
                    <Pagination color={'success'} total={skins.data.last_page} initialPage={skins.data.current_page}
                                className={'my-5'}
                                title={'pages'} onChange={page => {
                        fetchUrl(page);
                    }}/>
                </center>
            }

        </Box>
    );
}

